// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"public-mobile-content_component_wrapper__cKXCi","signUpButton":"public-mobile-content_component_signUpButton__3QKvX"};